/**
 * Persist the last-used tab in the Help & Feedback drawer so reopening
 * the FAB lands where the user left off. Stored in localStorage; falls
 * back gracefully when storage is unavailable / quota-locked.
 */

export type TabKey = 'submit' | 'mine' | 'support'

const STORAGE_KEY = 'evop:helpfeedback:lastTab'
const VALID: ReadonlySet<TabKey> = new Set(['submit', 'mine', 'support'])

export function readLastUsedTab(): TabKey | null {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (raw && VALID.has(raw as TabKey)) return raw as TabKey
  } catch {
    // Storage disabled or unavailable - silent fall-through.
  }
  return null
}

export function writeLastUsedTab(tab: TabKey): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, tab)
  } catch {
    // Quota / disabled storage - silent.
  }
}
